import { useState } from "react";
import { trackFunnelEvent } from "../utils/trackFunnelEvent";

// ✅ Base API: change ici et tout suit
const API_BASE = "https://marchedeluxe.ch/services";

export const useAuth = () => {
  const [authStatus, setAuthStatus] = useState("idle"); // idle | loading | error

  const login = async ({ email, password }) => {
    setAuthStatus("loading");
    try {
      const response = await fetch(`${API_BASE}/login.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json().catch(() => ({}));

      if (data?.success && data?.user) {
        localStorage.setItem("user_data", JSON.stringify(data.user));
        if (data.token) localStorage.setItem("user_token", data.token);
        trackFunnelEvent("login_success", {
          has_token: Boolean(data?.token),
          has_discount: Number(data?.user?.discount || 0) > 0,
        });
        setAuthStatus("idle");
        return data.user;
      }

      setAuthStatus("error");
      throw new Error(data?.message || "Identifiants incorrects");
    } catch (err) {
      setAuthStatus("error");
      console.error("DEBUG: Login error", err);
      throw err;
    }
  };

  const logout = async () => {
    try {
      await fetch(`${API_BASE}/logout.php`, {
        method: "POST",
        credentials: "include",
      });
    } catch (err) {
      console.error("DEBUG: Logout PHP error", err);
    } finally {
      localStorage.removeItem("user_data");
      localStorage.removeItem("user_token");
      setAuthStatus("idle");
      window.location.reload();
    }
  };

  return { login, logout, authStatus };
};
